import React from "react";
import { Tooltip } from "../../../../../../components/tooltip/tooltip/tooltip.component";
import { CheckCircleIcon } from "../../../../../../components/icon/icons/check-circle-icon.component";
import { TooltipTitle } from "../../../../../../components/tooltip/tooltip-title/tooltip-title.component";
import { TooltipBody } from "../../../../../../components/tooltip/tooltip-body/tooltip-body.component";
import { withShowIf } from "../../../../../../components/with-show-if/with-show-If.component";
import { BASE_COLORS } from "../../../../../../emotion-theme";
import { ProductStatusIndicatorTooltipProps } from "../../types/product-status-indicator-tooltip.props";

export const ProductStatusIndicatorTooltipConfirmed = withShowIf(
  (props: ProductStatusIndicatorTooltipProps) => (
    <Tooltip colour={BASE_COLORS.treeGreen} icon={CheckCircleIcon}>
      <TooltipTitle>{props.field} Confirmed</TooltipTitle>
      <TooltipBody>{props.field} has been confirmed by the system.</TooltipBody>
    </Tooltip>
  )
);
